import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
        const authReq = req.clone({
            setHeaders: {
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
              'Access-Control-Allow-Origin':'*'
            }
          });
    return next.handle(req);
  }
}

